import AsynAutoComplete from '../AsynAutoComplete/AsynAutoComplete';
// import commonApi from '../../../services/api/CommonApi';
import { memo, useCallback, useMemo } from 'react';
import useAuth from '../../../hooks/useAuth';
import ClientApi from '../../../services/api/ClientApi';
import { useLocation } from 'react-router-dom';
import { PageName } from '../../../utils/screenPermission';

// Usage

const PetrohubClientAutoComplete = ({
  label = 'Client',
  multiple = false,
  selectedItem,
  onValueChange,
  name,
  error,
  helperText,
  parameter,
  renderOptionDecorator = false,
  required,
  selectedClientList = [],
  extraFilter = null
}) => {
  const location = useLocation();
  const pages = useMemo(() => location.pathname.split('/').filter(Boolean)[0], [location]);
  const { assignedSourceSystems } = useAuth();
  // const isSearchOnType = !Array.isArray(assignedClients) || assignedClients.length === 0;
  const fetchDataHandler = useCallback(
    async (data) => {
      const { Data } = await ClientApi.fetchAllClientsFuel({
        ...data,
        clientName: data.text,
        sourceSystemIds: data.sourceSystemIds?.length ? data.sourceSystemIds : assignedSourceSystems,
        sortBy: 'ClientName',
        functionality: PageName[pages],
        ...extraFilter
      });
      if (Data) {
        let optionsData = Data.map((x) => ({ ...x, id: x.ClientID, text: x.ClientName }));
        if (selectedClientList?.length) {
          optionsData = optionsData.filter((option) => selectedClientList?.every((client) => parseInt(client?.client?.id, 10) !== parseInt(option?.id, 10)));
        }
        return optionsData;
      }
      return [];
    },
    [assignedSourceSystems, extraFilter, pages, selectedClientList]
  );

  const getOptionLabel = useCallback((option) => {
    if (typeof option === 'string') {
      return option;
    }

    if (typeof option === 'number') {
      return option;
    }

    return option.text;
  }, []);

  const isOptionEqualToValue = useCallback((option, value) => {
    if (!value) {
      return false;
    }

    if (typeof value === 'string') {
      return option.text.toLocaleLowerCase().trim() === value.toLocaleLowerCase().trim();
    }

    if (typeof value === 'number') {
      return option.id === value;
    }

    return option.id === value.id;
  }, []);

  return (
    <AsynAutoComplete
      multiple={multiple}
      label={label}
      required={required}
      isSearchOnType
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      selectedItem={selectedItem}
      onValueChange={onValueChange}
      onFetchData={fetchDataHandler}
      parameter={parameter}
      error={error}
      helperText={helperText}
      name={name}
      renderOptionDecorator={renderOptionDecorator}
      isVisibleSourceSystem={false}
    />
  );
};

export default memo(PetrohubClientAutoComplete);
